// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"577":"5027784a","784":"4c82f24e","825":"5027784a","984":"5027784a"}[chunkId] + ".chunk.css";
};